/* DownloadComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./DownloadRenderer");

class DownloadComponent extends EventEmitter {
    constructor(logger) {
        super();
        this._logger = logger;
        this.reportFormat = "csv";
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
                this._context = undefined;
                this.reportFormat = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "DownloadComponent.shutdown() error");
            }
        );
    }
    createAction() {
        this._context.resolve(this.reportFormat);
    }
    cancelAction() {
        this._context.reject({ userRejected: true });
    }
    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = DownloadComponent;
